/**
 * FloraHut Section Footer - Mobile Accordion & Interactions
 * Vanilla JS, accessible, ultra-lightweight.
 */
(function() {
  'use strict';

  function initFooterAccordion() {
    var menuHeaders = document.querySelectorAll('.ft-col--menu .ft-heading');
    if (!menuHeaders || !menuHeaders.length) return;

    menuHeaders.forEach(function(header) {
      var col = header.closest('.ft-col--menu');
      var list = col ? col.querySelector('.ft-links-list') : null;
      if (!list) return;

      if (!header.getAttribute('role')) {
        header.setAttribute('role', 'button');
        header.setAttribute('tabindex', '0');
        header.setAttribute('aria-expanded', 'false');
      }

      function toggle() {
        if (window.innerWidth > 767) return;
        var isOpen = col.classList.toggle('is-open');
        header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      header.addEventListener('click', toggle);
      header.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  } else {
    initFooterAccordion();
  }
})();
